import type { ThemeCodeStyle, ThemeComponentCode } from './types';
import { useThemeConfig } from './use-theme-config';
type GetStyleFromComponentCode<T extends ThemeComponentCode> = keyof ThemeCodeStyle[T];

export function useTheme<T extends ThemeComponentCode>(
  componentCode: T,
  ...themeArgs: GetStyleFromComponentCode<T>[] // 指定想应用的组件样式
): Record<string, any> {
  const styles: Record<string, any> = {};

  const context = useThemeConfig();

  if (!context) {
    return styles;
  }
  const componentStyle = context[componentCode] || {};
  if (themeArgs && themeArgs.length) {
    for (let index = 0; index < themeArgs.length; index++) {
      const key = themeArgs[index] as string;
      styles[`--${key}`] = componentStyle[key];
    }
  } else {
    for (const key in componentStyle) {
      if (Object.prototype.hasOwnProperty.call(componentStyle, key)) {
        const element = componentStyle[key];
        styles[`--${key}`] = element;
      }
    }
  }
  return styles;
}
